<template>
    <div class="indexTabs mt30">
        <el-tabs v-model="activeName" type="card" @tab-click="clickTabs">
            <template v-for="(item,i) in indexList">
                <el-tab-pane :label="item.title" :name="i.toString()" :key="i"></el-tab-pane>
            </template>
        </el-tabs>
            <div class="productIndex">
                <div class="indexLeft">
                    <div class="zshu_box">
                        当季：<span style="color:#329d15;">{{indexList[activeName].cur_rank}}</span>点<span style="margin-left:12px;">比上一拍卖季：</span>
                        <img class="jt jt_1" src="../../../../assets/imgs/jt_1.png" alt="" v-if="indexList[activeName].tend_num<0">
                        <img class="jt jt_2" src="../../../../assets/imgs/jt_2.png" alt="" v-else>
                        {{Math.abs(indexList[activeName].tend_num)}}%
                    </div>
                </div>
                <div class="indexRight" id="myChart0" :style="{width: '840px', height: '350px'}">
                </div>
                <!-- <div class="indexRight" id="myChart2" :style="{width: '840px', height: '350px'}">
                </div> -->
            </div>
    </div>
</template>

<script>
export default {
    props:{
        indexList:{
            type:Array
        }
    },
    name: "marks",
    data(){
        return{
            activeName:0,
        }
    },
    mounted() {
        this.clickTabs({index:0})
    },
    methods:{
        clickTabs(tab){
            let idx = tab.index;
            let myChart = this.$echarts.init(document.getElementById('myChart0'))
            myChart.setOption({
                title: { text: '' },
                tooltip: {
                    trigger: 'axis'
                },
				grid: {
					left: '5%',
					top:'5%',
					right: '3%',
					bottom: '3%',
					containLabel: true
				},
                xAxis: {
                    data: this.indexList[idx].year,
                    type: 'category',
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        //网格线
                        lineStyle: {
                        type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
                        width: 1,
                        //color:"red"
                        },
                        show: true, //隐藏或显示
                    },
                },
                series: {
                    data:this.indexList[idx].label_line,
                    type: 'line',
                    smooth: true, 
                    itemStyle : {  
                        normal : {  
                            color:'#329d15',//圆点颜色
                            lineStyle:{  
                                color:'#329d15'//线条颜色
                            }  
                        }  
                    },  
                    areaStyle: {
                        color: {//渐变色设置
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,  color: '#329d15'  // 100% 处的颜色
                            }, {
                                offset: 1, color: '#FFFFFF' //   0% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                    },
                },
            });

            /* let myChart2 = this.$echarts.init(document.getElementById('myChart2'))
            myChart2.setOption({
                title: { text: '' },
                tooltip: {
                    trigger: 'axis'
                },
				grid: {
					left: '5%',
					top:'5%',
					right: '3%',
					bottom: '3%',
					containLabel: true
				},
                xAxis: {
                    data: this.indexList[idx].year,
                    type: 'category',
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        //网格线
                        lineStyle: {
                        type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
                        width: 1,
                        //color:"red"
                        },
                        show: true, //隐藏或显示
                    },
                },
                series: {
                    data:this.indexList[idx].label_line,
                    type: 'bar',
                    smooth: true, 
                    itemStyle : {  
                        normal : {  
                            color:'#329d15',//圆点颜色
                            lineStyle:{  
                                color:'#329d15'//线条颜色
                            }  
                        }  
                    },  
                    areaStyle: {
                        color: {//渐变色设置
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,  color: '#329d15'  // 100% 处的颜色
                            }, {
                                offset: 1, color: '#FFFFFF' //   0% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                    },
                },
            }); */

        },

        /* clickTabs(tab){
            let idx = tab.index;
            let myChart = this.$echarts.init(document.getElementById('myChart0'))
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
				grid: {
					left: '0%',
					top:'10%',
					right: '0%',
					bottom: '0%',
					containLabel: true
				},
                toolbox: {
                    feature: {
                        dataView: {show: true, readOnly: false},
                        magicType: {show: true, type: ['line', 'bar']},
                        restore: {show: true},
                        saveAsImage: {show: true}
                    }
                },
                legend: {
                    data: ['指数', '成交额']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.indexList[idx].year,
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '指数',
                        axisLabel: {
                            formatter: '{value} 点'
                        }
                    },
                    {
                        type: 'value',
                        name: '成交额',
                        axisLabel: {
                            formatter: '{value} 元'
                        }
                    }
                ],
                series: [
                    {
                        name: '指数',
                        type: 'line',
                        data: this.indexList[idx].total_line,
                        smooth: true, 
                        itemStyle : {  
                            normal : {  
                                color:'#f5222d',//圆点颜色
                            }  
                        },  
                    },
                    {
                        name: '成交额',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: this.indexList[idx].label_line,
                        itemStyle : {  
                            normal : {  
                                color:'#329d15',//柱状图颜色
                            }  
                        },  
                    }
                ]
            });
        }, */

    }
}
</script>

<style scoped lang="scss">
.indexTabs{
    /deep/.el-tabs--card>.el-tabs__header .el-tabs__nav{border:0;border-radius: 0;margin-bottom: -1px;}
    /deep/.el-tabs--card>.el-tabs__header{border-color: #D9D9D9;margin-bottom:0;}
    /deep/.el-tabs__item{color:#262626;}
    /deep/.el-tabs--card>.el-tabs__header .el-tabs__item{border-left:0;}
    /deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{border:1px solid #d9d9d9;border-bottom-color: #fff;color:#329D15;font-weight: bold;}
    .productIndex{border:1px solid #d9d9d9;border-top: 0;padding:20px;}
    .indexLeft{width:100%;overflow:hidden;}
    .zshu_box{
        background:#f6f7f9;
        float:right;
        line-height:30px;
        padding:0px 12px;
        font-size:12px;
        color:#333;
    }
    .jt{
        width:7px;
        margin-right:4px;
    }
    .jt_1{
        margin-top:0px;
    }
    .jt_2{
        margin-top:-4px;
    }
}
</style>